import { render } from "./socialMedia.vue?vue&type=template&id=ae393968&scoped=true"
import script from "./socialMedia.vue?vue&type=script&lang=js"
export * from "./socialMedia.vue?vue&type=script&lang=js"

import "./socialMedia.vue?vue&type=style&index=0&id=ae393968&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae393968"]])

export default __exports__